import { memo } from "react";

export default memo(function LabelValuePill({
  label,
  value,
}: {
  label: string;
  value: string;
}) {
  return (
    <div
      className="px-2 py-1 rounded border border-gray-200 text-xs bg-white tracking-wide"
      role="listitem"
      aria-label={`${label}: ${value}`}
    >
      <span className="font-medium">{label}: </span>
      <span>{value}</span>
    </div>
  );
});
